import React, { useState } from 'react';
import { Lock, Mail } from 'lucide-react';
import { adminAuthApi } from '../services/adminApi';

interface Props { onLogin: () => void; }

const AdminLogin: React.FC<Props> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) { setError('Email et mot de passe requis'); return; }
    setError('');
    setLoading(true);
    try {
      await adminAuthApi.login(email.trim(), password);
      onLogin();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream-100 px-4 text-coffee-200">
      <div className="w-full max-w-sm rounded-2xl border border-cream-200/70 bg-white p-8 shadow-sm">
        <div className="mb-6 text-center">
          <img
            src="/assets/Logo_EAM.png"
            alt="EAM"
            className="mx-auto mb-3 h-14 w-14 object-contain"
            onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
          />
          <h1 className="font-display text-xl font-bold text-coffee-200">Espace admin</h1>
          <p className="mt-1 text-sm text-coffee-100">Eudora Aromas Madagascar</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-coffee-200">Email</label>
            <div className="relative">
              <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-coffee-100" aria-hidden="true" />
              <input
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                className="w-full rounded-lg border border-cream-200 bg-cream-50 py-2.5 pl-9 pr-3 text-sm outline-none transition-all focus:border-forest-200 focus:ring-2 focus:ring-forest-200/30"
                placeholder="vous@eudora-aromas.com"
                autoComplete="username"
              />
            </div>
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-coffee-200">Mot de passe</label>
            <div className="relative">
              <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-coffee-100" aria-hidden="true" />
              <input
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                className="w-full rounded-lg border border-cream-200 bg-cream-50 py-2.5 pl-9 pr-3 text-sm outline-none transition-all focus:border-forest-200 focus:ring-2 focus:ring-forest-200/30"
                placeholder="••••••••••••"
                autoComplete="current-password"
              />
            </div>
            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-forest-200 py-2.5 text-sm font-semibold text-cream-50 transition-colors hover:bg-forest-100 disabled:opacity-60"
          >
            {loading ? 'Connexion...' : 'Connexion'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
